<div class="context-container">
    <p class="context-helper">
        You can upload your resume or paste a job description to make the interview more relevant.
        <span class="optional-text">This step is optional.</span>
    </p>

    <!-- Upload Section -->
    <div class="upload-section">
        <h3 class="section-title">
            Upload Resume <span>(Optional)</span>
        </h3>

        <!-- File Preview (shown after upload) -->
        <div class="file-preview" *ngIf="uploadedFile">
            <div class="file-info">
                <i class="bi bi-file-earmark-text file-icon"></i>
                <div class="file-details">
                    <p class="file-name">{{ uploadedFile.name }}</p>
                    <p class="file-size">{{ uploadedFileSize }}</p>
                </div>
            </div>
            <i class="bi bi-x-circle remove-icon" (click)="removeFile()"></i>
        </div>

        <!-- Upload Box (default state) -->
        <div class="upload-box" *ngIf="!uploadedFile">
            <div class="upload-icon">
                <i class="bi bi-cloud-arrow-up"></i>
            </div>
            <p class="upload-text">Drag and drop your resume here</p>
            <p class="upload-subtext">Supports PDF, DOC, DOCX files up to 10MB</p>

            <label for="resumeFile" class="choose-btn">Choose File</label>
            <input type="file" id="resumeFile" hidden accept=".pdf,.doc,.docx" (change)="onFileSelected($event)" />
        </div>
    </div>


    <div class="divider"><span>OR ADD CONTEXT</span></div>

    <!-- Target Company -->
    <div class="input-section">
        <label for="company" class="input-label">
            <i class="bi bi-buildings-fill"></i> Target Company (Optional)
        </label>

        <div class="dropdown-container" [class.open]="isDropdownOpen">
            <div class="input-wrapper">
                <i class="bi bi-search search-icon"></i>
                <input id="company" type="text" class="dropdown-input"
                    placeholder="Search and select a company (e.g., Google, Microsoft...)" [(ngModel)]="searchTerm"
                    (focus)="openDropdown()" (input)="filterCompanies()" />
            </div>

            <ul class="dropdown-list" *ngIf="isDropdownOpen">
                <li *ngFor="let company of filteredCompanies" (click)="selectCompany(company, $event)"
                    class="dropdown-item" [class.active]="selectedCompany?.id === company.id">
                    {{ company.name }}
                </li>
                <li class="dropdown-item create-company" (click)="openCreateCompanyModal()">
                    <i class="bi bi-plus-lg"></i> Create New Company
                </li>

                <li *ngIf="filteredCompanies.length === 0" class="no-result">
                    No results found
                </li>
            </ul>
        </div>
    </div>


    <!-- Job Description -->
    <div class="input-section">
        <label for="jobDesc" class="input-label job"><i class="bi bi-file-earmark-text"></i>Job Description
            (Optional)</label>
        <textarea id="jobDesc" class="job-textarea"
            placeholder="Paste the job description here to get more relevant interview questions..." maxlength="2000"
            [(ngModel)]="jobDescription" (input)="onJobDescriptionChange()"></textarea>
        <div class="char-count">{{ jobDescription.length}}/2000 chars</div>
    </div>

    <!-- Tip Section -->
    <div class="tip-box">
        <div class="tip-icon">🎯</div>
        <div class="tip-content">
            <h4 class="tip-title">Get Personalized Questions</h4>
            <p class="tip-text">
                Adding context helps our AI create interview questions specific to your target role and company,
                making your practice session more realistic and valuable.
            </p>
        </div>
    </div>
    <div class="action-buttons">
        <button class="back-btn" (click)="back.emit()">
            ← Back
        </button>

        <div class="right-buttons">
            <button class="skip-btn" (click)="skip.emit()">Skip for now</button>
            <button class="continue-btn" (click)="onContinue()" [disabled]="jobDescription.length >= MAX_DESC_LENGTH">
                Continue →
            </button>
        </div>
    </div>
</div>
<!-- Company Modal -->
<app-company-create-dailog [show]="showCreateCompanyModal" (close)="showCreateCompanyModal = false"
    (companyCreated)="handleCompanyCreated($event)"></app-company-create-dailog>